<template>
  <el-dialog
    class="edit-setting-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="sendForm"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="区块链ID">
        <el-input v-model="editForm.ChainId" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="区块链名称">
        <el-input v-model="editForm.ChainName" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="区块链最大容量" prop="BlockTxCapacity">
        <counter ref="capacity" :unit="unit1" :edit-val="sendForm.BlockTxCapacity"></counter>
      </el-form-item>
      <el-form-item label="交易最大延时" prop="TxTimeout">
        <counter ref="txn" :unit="unit2" :edit-val="sendForm.TxTimeout"></counter>
      </el-form-item>
      <el-form-item label="出块间隔" prop="BlockInterval">
        <counter ref="interval" :unit="unit3" :edit-val="sendForm.BlockInterval"></counter>
      </el-form-item>
      <el-form-item label="修改理由" prop="Reason">
        <el-input
          v-model="sendForm.Reason"
          type="textarea"
          :resize="resize"
          :rows="3"
          placeholder="修改需其他组织同意，请输入理由"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'EditSetting',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    let validateZero = (rule, value, callback) => {
      if (value === 0) {
        return callback(new Error('输入不能为0'))
      } else {
        callback()
      }
    }
    return {
      title: '修改链配置',
      dialogVisible: false,
      disabled: false,
      unit1: '笔交易',
      unit2: 's',
      unit3: 'ms',
      resize: 'none',
      editForm: {
        ChainId: '',
        ChainName: ''
      },
      sendForm: {
        BlockInterval: 0,
        BlockTxCapacity: 0,
        Reason: '',
        TxTimeout: 0,
        ChainId: ''
      },
      editRule: {
        BlockInterval: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        BlockTxCapacity: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        TxTimeout: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validateZero, trigger: 'blur' }
        ],
        Reason: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  methods: {
    handleCancel() {
      this.$refs.editForm.clearValidate()
      this.disabled = false
      this.dialogVisible = false
    },
    handleOpen() {
      this.getData()
      this.dialogVisible = true
    },
    getData() {
      let info = JSON.parse(this.$route.query.detail)
      Object.keys(this.sendForm).map(ele => {
        this.sendForm[ele] = info[ele] || ''
      })
      this.editForm.ChainId = info.ChainId
      this.editForm.ChainName = info.ChainName
    },
    handleOk() {
      this.sendForm.BlockInterval = this.$refs.interval.getCount()
      this.sendForm.TxTimeout = this.$refs.txn.getCount()
      this.sendForm.BlockTxCapacity = this.$refs.capacity.getCount()
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.disabled = true
          this.$apis.chain.modifySetting(this.sendForm).then(res => {
            if (res) {
              this.$message.success('更新链配置开始投票！')
              this.handleCancel()
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
